var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportsEngins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28.1595L11.6064 39.1382L8.86169 36.3935L19.8404 24.4999M23.5 28.1595L24.8723 29.5318L28.9894 28.1595L32.2612 30.9708L28.9894 34.1063L39.9681 23.585L25.3298 8.48926L17.5532 15.8084M23.5 28.1595L19.8404 24.4999M14.8085 18.5531L17.5532 15.8084M17.5532 15.8084L20.7553 19.468L18.9255 23.585L19.8404 24.4999",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.617,
    cy: 21.298,
    r: 2.40957,
    stroke: "#A3AED0",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.03192,
    cy: 40.9682,
    r: 3.78192,
    stroke: "#A3AED0",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 36.8511L3.82979 38.6809M9.7766 44.1702L11.6064 46",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5319 5.74487L43.1702 20.8406",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2765 3L45.9148 18.0957",
    stroke: "#A3AED0",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportsEngins);
export default __webpack_public_path__ + "static/media/TransportsEngins.95b7349bcde9f4678200ddd7fd439d55.svg";
export { ForwardRef as ReactComponent };